<template>
  <div class="main-area py-4">
    <div
      class="md:py-6 p-5 md:px-30 form-design-color"
      id="alert_image_overlay"
    >
      <div class="login-banner pt-8 md:pt-0 flex items-center justify-center">
        Welcome back!
      </div>
      <div class="login-header pt-4 text-center">
        Sign In to BuyHive
        <br/>
                as a 
                <span v-if="LoginSelectionMode == 'buyer'" >Buyer</span>
                <span v-else >Sourcing Expert</span>
      </div>
      <div class="md:pt-6 md:pb-0 p-5 md:px-18">
        <Form class="md:px-10" @submit="onSubmit">
          <div class="">
            <Field
              name="email"
              class="form-input"
              placeholder="E-mail Address"
              :rules="validateEmail"
              v-model="formData.login"
            />
            <div class="h-3 lg:h-5">
              <ErrorMessage name="email" class="form-error" />
            </div>
          </div>
          <div class="pt-4">
            <div class="w-full items-center">
              <Field
                name="password"
                class="form-input"
                type="password"
                placeholder="Password"
                :rules="isRequired"
                v-model="formData.password"
              />
              <div class="h-3 lg:h-5">
                <ErrorMessage name="password" class="form-error" />
              </div>
            </div>
          </div>
          <div>
            <div
              class="inline-flex items-center cursor-pointer"
              @click="rememberMe = !rememberMe"
            >
              <input
                type="checkbox"
                value="true"
                v-model="rememberMe"
                class="w-4 h-4"
              />
              <span class="pl-4 opacity-50">Keep me Signed In</span>
            </div>
          </div>
          <div class="flexbox text-center pt-2 md:pt-6">
            <button class="new-app-btn bg-blue mt-6 sm:mt-0 font-semibold">
              Sign In
            </button>
            <br />
            <p
              v-if="LoginSelectionMode == 'buyer'"
              class="font-normal pt-2 pb-2"
            >
              or
            </p>

            <button
              v-if="LoginSelectionMode == 'buyer'"
              class="new-app-btn bg-green font-semibold pt-8"
              @click="authenticate"
              type="button"
            >
              Sign In with LinkedIn
            </button>
          </div>
        </Form>
        <div
          style="font-weight: 600;"
          class="pt-4 md:pt-6 text-center md:text-xl tracking-tighter"
        >
          Don’t have an account?
          <a
            v-if="LoginSelectionMode == 'freelancer'"
            :href="freelancer_registration_link"
            class="text-blue underline"
          >
            Create one!
          </a>
          <a
            v-else
            :href="buyer_registration_link"
            class="text-blue underline"
          >
            Create one!
          </a>
          <br />
          <span class="forgot-password md:text-lg font-normal tracking-tighter">
            Forgot password?
            <button @click="openForgetPassword()" class="text-green underline">
              Click here to create new one.
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VeeValidate from "@/shared/mixins/VeeValidate";
export default {
  name: "Alert",
  mixins: [VeeValidate],
  beforeRouteEnter: async (to, from, next) => {
    document.title = 'Sign In',
    next()
  },
  data() {
    return {
      formData: {
        login: "",
        password: "",
      },
      rememberMe: false,
      baseURL: process.env.VUE_APP_SERVER_BASE_URL,
      freelancerURL:
        this.LoginSelectionMode == "freelancer"
          ? process.env.VUE_APP_FREELANCER_HOME_PATH
          : process.env.VUE_APP_BUYER_HOME_PATH,
      buyer_registration_link: `${process.env.VUE_APP_BUYER_HOME_PATH}/register`,
      freelancer_registration_link: `${process.env.VUE_APP_FREELANCER_HOME_PATH}/register`,
    };
  },
  computed: {
    ...mapGetters(["LoginSelectionMode", "isUserLoggedIn"]),
  },
  methods: {
    ...mapActions([
      "openLoginModal",
      "login",
      "openForgetPasswordModal",
      "loginWithLinkedIn",
    ]),
    closeAlertModal() {
      this.openLoginModal(false);
    },
    openForgetPassword() {
      this.openLoginModal(false);
      this.openForgetPasswordModal(true);
    },
    async onSubmit() {
      const response = await this.login({
        formData: this.formData,
        rememberMe: this.rememberMe,
      });
      if (response.result && this.isUserLoggedIn) {
        localStorage.removeItem("supplierCriteriaDetails");
        localStorage.removeItem("existingSourcingToken");
        localStorage.removeItem("activeTab");
        if(response.role == "buyer") {
          if(localStorage.getItem('previousUrl')) {
            let previous_url = localStorage.getItem('previousUrl')
            localStorage.removeItem('previousUrl')
            window.location.href = previous_url
          } else {
            window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
          }
        }
        else if (response.role == "freelancer" && response.email_verified == false) {
          this.$router.push({ name: "EmailVerification" });
        } 
        else if (
          response.role == "freelancer" &&
          response.email_verified &&
          response.status != "active"
        ) {
          this.$router.push({ name: "AccountReview" });
        } else if (
          response.role == "freelancer" &&
          response.email_verified &&
          response.status == "active"
        ) {
          this.$router.push({ name: "ProfileVerified" });
        }
        else if (response.role == "buyer" && localStorage.getItem('previousUrl')) {
          let prev_url = localStorage.getItem('previousUrl')
          localStorage.removeItem('previousUrl')
          window.location = prev_url
        } else if (this.$route.query.prev) {
          this.$router.push(`${this.$route.query.prev}`);
        } else {
          // this.$router.push({name: 'Home'})
          window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`;
        }
      } else {
        this.$notify({
          group: "buyHive",
          type: "error",
          text: response.message,
        });
      }
    },
    async authenticate() {
      if (localStorage.getItem("previousUrl") == null) {
        if (this.$route.query.prev == "/checkout") {
          localStorage.setItem(
            "previousUrl",
            `${process.env.VUE_APP_BUYER_HOME_PATH}/checkout`
          );
        } else {
          localStorage.setItem("previousUrl", window.location.href);
        }
      }
      this.openLoginModal(false);
      const response = await this.loginWithLinkedIn();
      if (response.result) window.location.href = response.url;
    },
  },
};
</script>

<style lang="scss" scoped>
// .main-area {
//   background: linear-gradient(180deg, #dcfbff 0%, #f9fff0 100%);
// }
.alert-modal {
  @apply fixed px-5 h-full inset-0 bg-dark z-50 bg-opacity-50 text-base flex  transition-all duration-150 ease-linear;
  .alert-area {
    @apply z-10 m-auto align-middle rounded-lg w-full;
    @screen md {
      width: 680px;
    }
    &__content {
      @apply rounded-lg;
      max-height: calc(100vh - 10px);
      overflow: auto;
      &__header {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
        button {
          @apply text-lg font-bold w-1/2 py-2.5;
          @screen md {
            @apply text-2xl;
          }
        }
      }
      .switch {
        @apply relative inline-block w-20 h-9;
      }
      .switch input {
        @apply h-0 w-0 h-0;
      }

      .slider {
        @apply absolute cursor-pointer inset-0;
        background-color: #00b3c9;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      .slider:before {
        @apply absolute bg-white h-7 w-7;
        content: "";
        left: 4px;
        bottom: 4px;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }

      input:checked + .slider {
        background-color: #8dc63f;
      }
      input:focus + .slider {
        box-shadow: 0 0 1px #8dc63f;
      }
      .slider.round {
        border-radius: 34px;
      }
      .slider.round:before {
        border-radius: 50%;
      }

      input:checked + .slider:before {
        -webkit-transform: translateX(42px);
        -ms-transform: translateX(42px);
        transform: translateX(42px);
      }
      .info-box {
        @apply pt-5 px-6 pb-2;
        background: rgba(0, 179, 201, 0.2);
        @screen md {
          @apply px-12;
        }
      }
    }
  }

  /* width */
  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: rgba(35, 31, 32, 0.15);
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #a0aec0;
  }
}
#close-btn {
  position: relative;
}
#alert_image_overlay {
  // position: relative;
  margin: 1em auto;
  width: 40%;
  @media (max-width: 768px)  {
    width: 85%;
  }
}
#alert_image_overlay #close-btn {
  position: absolute;
  top: 17px;
  right: 20px;
  content: "";
}
.form-design-color{
  background: white;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
}

.new-app-btn {
  @media(min-width: 768px) {
    font-weight: 700 !important;
    font-size: 20px !important;
  }
  @apply rounded-full px-8 text-lg py-2 text-white;
}

.login-header {
  color: #00b2c9;
  font-size: 28px;
  line-height: 38.25px;
  font-weight: 600;
}
.login-banner {
  font-weight: 500;
  font-size: 20px;
  line-height: 27.32px;
}
.forgot-password {
  @media (min-width: 768px) {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  }
}
</style>